import { useMemo } from "react";
import {
  CancerType,
  nivolumabOptions,
  TherapyOption,
  NivolumabOptions,
} from "../../../data/nivoConsts";
import useTherapyDrugs from "../../../hooks/useTherapyDrugs";

export interface DischargeSummaryProps {
  formObject: any;
  updateFormObject: (key: string, value: any) => void;
  formData: any;
  showTherapyError: boolean;
  showIndicationError: boolean;
  setShowTherapyError: (error: boolean) => void;
  setShowIndicationError: (error: boolean) => void;
}

const useDischargeSummary = (props: DischargeSummaryProps) => {
  const { formObject, updateFormObject, formData, showTherapyError, showIndicationError, setShowTherapyError, setShowIndicationError } = props;

  // Fetch therapy drugs from API
  const { getCancerTypesForPrimary, isLoading: loadingDrugs } = useTherapyDrugs();

  // const selectedNivolumab = useMemo(() => {
  //   return nivolumabOptions[formData.primaryDrug as keyof NivolumabOptions];
  // }, [formData.primaryDrug]);

  // console.log(selectedNivolumab, "selectedNivolumab");
  // console.log("getCancerTypesForPrimary", getCancerTypesForPrimary(formData.primaryDrug));

  // const approvalOptions = useMemo(() => {
  //   return (
  //     selectedNivolumab?.find(
  //       (cancerType: CancerType) => cancerType.value === formData.cancerType
  //     )?.therapies ?? []
  //   );
  // }, [selectedNivolumab, formData.cancerType]);

  // const therapyOptions = useMemo(() => {
  //   return (
  //     approvalOptions.find(
  //       (therapy: TherapyOption) => therapy.value === formObject.therapy
  //     )?.indications ?? []
  //   );
  // }, [approvalOptions, formObject.therapy]);

  // Get cancer types for selected primary drug from API
  const cancerTypesForPrimaryDrug = useMemo(() => {
    if (!formData.primaryDrug) return [];
    return getCancerTypesForPrimary(formData.primaryDrug);
  }, [formData.primaryDrug, getCancerTypesForPrimary]);

  // Get therapies for selected cancer type
  const therapyOptions = useMemo(() => {
    if (!formData.cancerType) return [];
    const selectedCancerType = cancerTypesForPrimaryDrug.find(
      (cancerType) => cancerType.value === formData.cancerType
    );
    return selectedCancerType?.therapies || [];
  }, [cancerTypesForPrimaryDrug, formData.cancerType]);

  // Get indications for selected therapy
  const indicationOptions = useMemo(() => {
    if (!formData.therapy) return [];
    const selectedTherapy = therapyOptions.find(
      (therapy) => therapy.value === formData.therapy
    );
    return selectedTherapy?.indications || [];
  }, [therapyOptions, formData.therapy]);


  const handleChange = (e: any) => {
    const value = e.target.value;
    const key = e.target.name;
    updateFormObject(key, value);
    if (key === "therapy") {
      setShowTherapyError(false);
    }
    if (key === "therapy_indication") {
      setShowIndicationError(false);
    }
  };

  return {
    formData,
    formObject,
    therapyOptions,
    indicationOptions,
    updateFormObject,
    handleChange,
    showTherapyError,
    showIndicationError,
  };
};

export default useDischargeSummary;
